/**
 * Export all configuration
 */

export * from './user-management-config';
